import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import axios from "axios";

Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(VueRouter);

var router = new VueRouter({
  routes: routes
});

new Vue({
  vuetify,
  router: router,
  render: h => h(App)
}).$mount("#app");
